// import { common } from "./_common";
import { modal } from "./_modal";
import { test } from "./_test";

// common();
modal();
test();
